import { ReportDateType } from 'wb-reddit/graphql/generated';
import { useMemo } from 'react';
import dayjs from 'dayjs';
import { getScheduleButtonName, getScheduleName } from 'wb-reddit/app/routes/reports/utils';
import { isSpotify } from '@aleph/shared-components';
import { SpotifyReportSchedule } from 'wb-spotify/app/common/utils';

const useTransformRedditSchedule = (selectedSchedule?: ReportDateType) => {
	const scheduleName = useMemo(() => getScheduleName(selectedSchedule), [selectedSchedule]);

	const scheduleNameButton = useMemo(() => getScheduleButtonName(selectedSchedule), [selectedSchedule]);

	const scheduleTimeUnit = useMemo((): dayjs.ManipulateType | undefined => {
		if (isSpotify()) {
			const selected = selectedSchedule as unknown as SpotifyReportSchedule;

			switch (selected) {
				case SpotifyReportSchedule.OnlyOnce:
					return 'day';
				case SpotifyReportSchedule.EveryMonday:
				case SpotifyReportSchedule.EveryWeekday:
					return 'week';
				case SpotifyReportSchedule.FirstOfTheMonth:
					return 'month';
				default:
					return undefined;
			}
		}

		switch (selectedSchedule) {
			case ReportDateType.Yesterday:
				return 'day';
			case ReportDateType.PreviousWeek:
			case ReportDateType.Biweekly:
				return 'week';
			case ReportDateType.PreviousMonth:
			case ReportDateType.Previous_3Months:
				return 'month';
			case ReportDateType.PreviousYear:
				return 'year';
		}

		return undefined;
	}, [selectedSchedule]);

	const scheduleTimeValue = useMemo(() => {
		if (isSpotify()) {
			const selected = selectedSchedule as unknown as SpotifyReportSchedule;

			switch (selected) {
				case SpotifyReportSchedule.OnlyOnce:
				case SpotifyReportSchedule.EveryMonday:
				case SpotifyReportSchedule.EveryWeekday:
				case SpotifyReportSchedule.FirstOfTheMonth:
					return 1;
				default:
					return null;
			}
		}

		switch (selectedSchedule) {
			case ReportDateType.Yesterday:
			case ReportDateType.PreviousWeek:
			case ReportDateType.PreviousMonth:
			case ReportDateType.PreviousYear:
				return 1;
			case ReportDateType.Biweekly:
				return 2;
			case ReportDateType.Previous_3Months:
				return 3;
		}

		return null;
	}, [selectedSchedule]);

	return {
		scheduleName, scheduleNameButton, scheduleTimeUnit, scheduleTimeValue,
	};
};

export default useTransformRedditSchedule;
